<template>
    <v-btn :disabled="disabled"
           color="primary"
           class="mr-4"
           v-bind="$attrs"
           @click="pressed">
        {{label}}
    </v-btn>
</template>

<script>
  export default {
    name: "PrimaryButton",
    inheritAttrs: false,
    props: {
      label: {required: true},
      disabled: {default: false}
    },
    methods: {
      pressed () {
        this.$emit('pressed')
      }
    }
  }
</script>

<style scoped>

</style>